export default __webpack_public_path__ + "static/media/download-bg.cf6d39f4.jpg";